module.exports = __webpack_public_path__ + "resources/img/pc_banner7.23ad1490126b393731f7e13f5e75f74b.png";